'use client';
import type { StaticPageHeaderType } from './data';

import { Breadcrumb, Container } from '@/components';
import { routes } from '@/statics';

const StaticPageHeader: StaticPageHeaderType = ({ title }) => {
  return (
    <Container>
      <Breadcrumb
        list={[
          { title: routes.home.title, href: routes.home.url },
          {
            title: title,
            href: routes.staticPages.url,
          },
        ]}
      />
    </Container>
  );
};
export default StaticPageHeader;
